import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'
import { getFirestore } from 'firebase/firestore'
import { getStorage } from 'firebase/storage'

// Firebase configurations for different environments
const firebaseConfigs = {
	production: {
		apiKey: 'AIzaSyB3FPzMrFHT_qXnoEEpisOd2iOrSrpPVnA',
		authDomain: 'mockingbird-7704d.firebaseapp.com',
		projectId: 'mockingbird-7704d',
		storageBucket: 'mockingbird-7704d.firebasestorage.app',
		messagingSenderId: '957227335576',
		appId: '1:957227335576:web:ffbc1bbe219fb38a4575ed',
		measurementId: 'G-0XP9CDW12M',
	},
	nonproduction: {
		apiKey: 'AIzaSyD53pUYBd_A6A5Lra4CJne3zEtNuFxIHAU',
		authDomain: 'non-prod-lexicon-labs.firebaseapp.com',
		projectId: 'non-prod-lexicon-labs',
		storageBucket: 'non-prod-lexicon-labs.firebasestorage.app',
		messagingSenderId: '145859632134',
		appId: '1:145859632134:web:f2af62f8c42884caeff787',
		// measurementId: 'G-XXXXXXXXXX', // Not enabled for nonproduction
	},
}

// Determine the current environment
const getCurrentEnvironment = (): 'production' | 'nonproduction' => {
	if (process.env.REACT_APP_ENV === 'production') {
		return 'production'
	}
	// TODO keep for future environments
	// Default to nonproduction for development/staging
	return 'nonproduction'
}

// Get the appropriate Firebase configuration
const getFirebaseConfig = () => {
	const environment = getCurrentEnvironment()
	const config = firebaseConfigs[environment]

	console.log(`Using Firebase configuration for: ${environment}`)
	return config
}

const firebaseConfig = getFirebaseConfig()
const firebaseApp = initializeApp(firebaseConfig)

export const auth = getAuth(firebaseApp)
export const db = getFirestore(firebaseApp)
export const storage = getStorage(firebaseApp)
